module.exports = __webpack_public_path__ + "img/Split chevron Icon - charcoal.e1ce6dfa.svg";